/**
 * Header API functions
 */

import { HeaderData, StrapiResponse } from '../types';
import { STRAPI_URL } from './base';

/**
 * Fetch header data
 * @returns Promise with header data
 */
export async function fetchHeaderData(): Promise<HeaderData> {
  try {
    const response = await fetch(`${STRAPI_URL}/api/header`, {
      headers: {
        'Content-Type': 'application/json',
        ...(process.env.NEXT_PUBLIC_STRAPI_API_TOKEN && {
          Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
        }),
      },
    });

    if (!response.ok) {
      console.error('HTTP error! status:', response.status);
      throw new Error(`Failed to fetch header data: ${response.status}`);
    }

    const result: StrapiResponse<HeaderData> = await response.json();

    if (!result.data) {
      throw new Error('No header data found');
    }

    return result.data;
  } catch (error) {
    console.error('Error fetching header data:', error);
    throw error;
  }
}
